export enum Right {
    // Admin rights
    ManageUsers = 'ManageUsers',
    ManageCompanies = 'ManageCompanies',
    Companies = 'Companies',
    ManageCoatingConfigurator = 'ManageCoatingConfigurator',
    ManageBranches = 'ManageBranches',
    Branches = 'Branches',
    ManageRoles = 'ManageRoles',
    ExpertAdviceModule = 'ExpertAdviceModule',
    AdviceModule = 'AdviceModule',
    ManageKnowledgeBase = 'ManageKnowledgeBase',


    // Company User rights
    CompanyUserManageUsers = 'CompanyUserManageUsers',
    CompanyUserDeliveryNotes = 'CompanyUserDeliveryNotes',
    CompanyUserInvoices = 'CompanyUserInvoices',
    CompanyUserKnowledgeBase = 'CompanyUserKnowledgeBase',
    CompanyUserAdviceModule = 'CompanyUserAdviceModule'
}

export enum RightType {
    Admin = 0,
    CompanyUser = 1
}
